import React from 'react';
import PageScreenDefault from '../../components/screen/PageScreenDefault';

const Home = () => <PageScreenDefault />;
export default Home;
